// extracted by mini-css-extract-plugin
export default {"container":"Container_container__MM274","body":"Container_body__fSbHb"};